<template>
  <a-modal title="查看计算结果" :visible="visible.result" :bodyStyle="{ padding: '10px' }" @ok="ok" @cancel="cancel" :maskClosable="false" :forceRender="true" :destroyOnClose="true" :zIndex="100000" width="1100px" okText="应用" cancelText="取消">
    <a-table :columns="columns" :data-source="list" :row-key="record => record.code" :scroll="{ x: 0, y: 360 }" :pagination="false">
      <!--差异-->
      <div
        style="text-align:center"
        slot="action"
        slot-scope="text, record"
        :class="{
          red: (record.nutritionValue === null && record.culationValue === null) || (record.nutritionValue === '' && record.culationValue === '') ? false : culation(record) != '-' && culation(record) > 0,
          green: (record.nutritionValue === null && record.culationValue === null) || (record.nutritionValue === '' && record.culationValue === '') ? false : culation(record) != '-' && culation(record) < 0
        }"
      >
        {{ culation(record) }}
      </div>
      <span slot="nutritionValue" slot-scope="text, record">
        {{ text === null ? text : Number(text).toFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 4 : 4) }}
      </span>
      <span slot="culationValue" slot-scope="text, record">
        {{ text === null ? text : Number(text).toFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 4 : 4) }}
      </span>
    </a-table>
  </a-modal>
</template>
<script>
import { nhfMixins } from '../../untils'
export default {
  mixins: [nhfMixins],
  data() {
    return {
      columns: [
        {
          dataIndex: 'typeName',
          title: '指标类型',
          width: 240
        },
        {
          dataIndex: 'code',
          title: '代码',
          width: 150
        },
        {
          dataIndex: 'name',
          title: '营养指标',
          width: 100
        },
        {
          dataIndex: 'nutritionValue',
          scopedSlots: { customRender: 'nutritionValue' },
          title: '原先值',
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          width: 150
        },
        {
          dataIndex: 'culationValue',
          title: '计算值',
          scopedSlots: { customRender: 'culationValue' },
          sorter: (a, b) => a.culationValue - b.culationValue,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          scopedSlots: { customRender: 'action' },
          align: 'center',
          sorter: (a, b) => ((b.nutritionValue || 0) - (b.culationValue || 0)) - ((a.nutritionValue || 0) - (a.culationValue || 0)),
          sortDirections: ['descend', 'ascend'],
          title: '差异'
        },
        {
          dataIndex: 'unit',
          align: 'center',
          title: '计量单位',
          width: 90
        }
      ],
      list: [],
      otherList: []
    }
  },
  watch: {
    rawResult(val) {
      if (val.length) {
        let resList = JSON.parse(JSON.stringify(val))
        this.list = resList.filter(e => e.typeId !== '1386613070176682199')
        let ls = resList.filter(e => e.typeId === '1386613070176682199')
        ls && ls.map(el => {
          el.nutritionValue = el.culationValue
          return el
        })
        this.otherList = ls
      }
    }
  },
  methods: {
    // 差异
    culation(record) {
      let val = 0
      const {culationValue,nutritionValue} = record
      if ((nutritionValue === null && culationValue === null) || (culationValue === '' && nutritionValue === '')) {
        val = '-'
      } else {
        // val = this.sub(!culationValue ? 0 : Number(culationValue).toFixed(4), !nutritionValue ? 0 : Number(nutritionValue.toFixed(4))).toFixed(4)
        val = (Number(culationValue || 0) - Number(nutritionValue || 0)).toFixed(4)
        val = val == '0.0000' || val == '0' ? '-' : val
      }
      return val
      // if ((!record.nutritionValue && record.nutritionValue !== 0) && (!record.culationValue && record.culationValue !== 0)) {
      //   val = '-'
      // } else {
      //   val = this.sub(Number(record.culationValue).toFixed(4), Number(record.nutritionValue).toFixed(4)).toFixed(4)
      //   val = val == '0.0000' || val == '0' ? '-' : val
      // // }
      // return val
    },

    itemChange(val, column) {
      const { nutritionId } = val
      let newData = [...this.list]
      let target = newData.filter(item => nutritionId === item.nutritionId)[0]
      let dm = newData.filter(i => i.name === 'DM')[0]
      let moisture = newData.filter(i => i.name === 'Moisture')[0]

      if (target) {
        let value = (val[column] === null || val[column] === '') && (target.name === 'Moisture' || target.name === 'DM') ? 0 : val[column]
        target[column] = value
        if (target.name === 'DM') {
          moisture.culationValue = 100 - value
        }
        if (target.name === 'Moisture') {
          dm.culationValue = 100 - value
        }
        this.list = newData
      }
    },

    ok() {
      this.toggleVisible('result')
      this.$emit('ok', this.list,this.otherList)
    },
    cancel() {
      this.toggleVisible('result')
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  position: relative !important;
}
.ant-table-row-cell-break-word {
  position: relative !important;
}
.green,
.red {
  display: flex;
  align-items: center;
  justify-content: center;
}
.green {
  color: green;
  &::before {
    content: '';
  }
}
.red {
  color: red;
  &::before {
    content: '+';
  }
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  position: relative;
}
</style>
